import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import TBCBPageWrapper from "src/components/Promotions/TBCB/TBCBPageWrapper";
import TBCBPrizeTablesSection from "src/components/Promotions/TBCB/TBCBPrizeTablesSection";
import TBCBHowItWorksSection from "src/components/Promotions/TBCB/TBCBHowItWorksSection";

const TripleBarrelCashBlast2025AnniversaryEdition = () => {
  const { t } = useTranslation();

  return (
    <TBCBPageWrapper>
      <EventFinished
        scheduleKeyName="tripleBarrelCashBlast2025AnniversaryEdition"
        eventType="promotion"
      />
      <Hero
        image={t("tripleBarrelCashBlast2025AnniversaryEdition.hero.image")}
        bgImage={t("tripleBarrelCashBlast2025AnniversaryEdition.hero.bgImage")}
        imageAlt={t("tripleBarrelCashBlast2025AnniversaryEdition.hero.imageAlt")}
        fluidImage={"hero?.image" ? false : true}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t("tripleBarrelCashBlast2025AnniversaryEdition.content.title")}
          text={t("tripleBarrelCashBlast2025AnniversaryEdition.content.subtitle")}
          borderColor="#d59947"
          className="mt-4 pb-2"
        />
        <ReactMarkdown>
          {t("tripleBarrelCashBlast2025AnniversaryEdition.content.text")}
        </ReactMarkdown>
        <TBCBPrizeTablesSection
          translationKeyPrefix="tripleBarrelCashBlast2025AnniversaryEdition"
          imagePath="2025"
        />
      </container-div>
      <TBCBHowItWorksSection translationKeyPrefix="tripleBarrelCashBlast2025AnniversaryEdition" />
    </TBCBPageWrapper>
  );
};

export default TripleBarrelCashBlast2025AnniversaryEdition;
